import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home";
import Cards from "@/views/Cards";
import About from "@/views/About";
import Score from "@/views/Score";
import Empty from "@/views/Empty";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/cards/:application",
    name: "Cards",
    component: Cards,
    props: true,
  },
  { path: "/score", name: "Score", component: Score },
  { path: "/about", name: "About", component: About },
  {
    path: "/expert",
    name: "Expert",
    component: () =>
      import(
        /* webpackChunkName: "expert" */
        /* webpackMode: "lazy" */
        "@/components/expert/Expert"
      ),
  },
  { path: "/empty", name: "Empty", component: Empty },
];

const router = new VueRouter({
  routes,
});

export default router;
